/**
 * Verifica se un oggetto ha coordinate lat/lng valide
 */
export function hasCoordinates(obj: Record<string, unknown>): { lat: number; lng: number } | null {
  const lat = Number(obj.latitudine);
  const lng = Number(obj.longitudine);
  if (lat && lng && !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
    return { lat, lng };
  }
  return null;
}

/**
 * Apre Google Maps in modalità navigazione verso le coordinate
 */
export function navigateTo(lat: number, lng: number) {
  window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`, '_blank');
}

/**
 * Restituisce la query per Google Maps embed (solo coordinate)
 */
export function getMapQuery(lat: number, lng: number): string {
  return `${lat},${lng}`;
}
